import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Injector, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { FrameContext } from '@farris/devkit';
import { BefRepository, BefRestService } from '../appointment-calendar/types';

type SizeConfig = {
  'headerHeight'?: number,
  'footerHeight'?: number,
  'rowHeight'?: number,
  'checkboxColumnWidth'?: number,
  'lineNumberWidth'?: number,
  'filterRowHeight'?: number
};


@Directive({ selector: '[custom-size]' })
export class CustomDatagridSizeDirective implements OnInit, AfterViewInit, OnChanges {
  @Input('custom-size') useCustomSize = false;
  @Input() sizeApiUri = '';

  private restService(): BefRestService {
    return (this.frameContext.repository as BefRepository).restService;
  }

  constructor(private dg: DatagridComponent, private injector: Injector, private cd: ChangeDetectorRef, private el: ElementRef,
    private frameContext: FrameContext) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sizeApiUri && !changes.sizeApiUri.isFirstChange()) {
      this.applyNewSize();
    }
  }

  ngAfterViewInit(): void {
    this.applyNewSize();
  }

  private applyNewSize() {
    if (this.useCustomSize && this.sizeApiUri) {
      this.getSizeConfig().subscribe((cfg: SizeConfig) => {
        if (this.dg && typeof this.dg.applyNewSize === 'function') {
          this.dg.applyNewSize(cfg);
        }
      });
    }
  }


  private getSizeConfig() {
    return this.restService().request(this.sizeApiUri, 'get');
  }
}
